import { HttpContextToken } from '@angular/common/http';

/**
 * The error statuses a request's caller shows itself: the global error toast stays quiet for them (a Julia table
 * that expired goes back to its text instead of showing an error).
 */
export const CALLER_HANDLED_STATUSES = new HttpContextToken<number[]>(() => []);
